import { combineReducers } from "redux";
import user from "./user";
import alert from './alert'
import status from './status'
import role from './role'
import loadingForSyncErpStudents from "./erpSyncStudentsLoader"
import loadingForSyncFeeWithErpStudents from "./erpSyncFeeWithStudentsLoader"
import loadingForAllSyncButtons from "./allSyncButtonsLoader";

const reducers = combineReducers({
  user,
  alert,
  status,
  role,
  loadingForSyncErpStudents,
  loadingForSyncFeeWithErpStudents,
  loadingForAllSyncButtons
});

const rootReducer = (state, action) => {
  // Clear persistant storage on logout
  // Dispatch RESET_APP on logout
  if (action.type === "RESET_APP") {
    state = {};
  }

  return reducers(state, action);
};

export default rootReducer;
